import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

const DatePicker = React.createClass({
  displayName: 'DatePicker',

  getDefaultProps: function () {
    return {
      disabled: false,
      name: '',
      value: ''
    };
  },

  propTypes: {
    name: React.PropTypes.string
  },

  onChangeDateTime: function (date) {
    let value = moment.utc(date, "YYYY-MM-DD").toDate().getTime();
    this.props.onChange(this.props.name, value);
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).datetimepicker({
      format: 'Y-m-d',
      mask: true,
      timepicker: false,
      value: this.props.value ? moment.utc(this.props.value).format("YYYY-MM-DD") : '',
      onChangeDateTime: this.onChangeDateTime
    });
  },

  render: function () {
    return (
      <input
        name={this.props.name}
        disabled={this.props.disabled}
      />
    );
  }
});

export default DatePicker;



// WEBPACK FOOTER //
// ./src/js/Component/DatePicker.jsx